export const getImagePath = (imageName) => {
  try {
    return require(`../assets/contacts/${imageName}`);
  } catch (error) {
    return require('../assets/contacts/default.jpg');
  }
};
